var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.value !== null)?_c('div',{staticClass:"ProgressBar__root"},[_c('div',{staticClass:"ProgressBar__fill",style:({ width: (Number(this.value) * 100) + '%'})})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }